import {
  DOPAMINE_PANEL_SNAP_TO_DEFAULT_PX,
  DOPAMINE_PANEL_WIDTH_STORAGE_KEY,
  DopamineAssistantStorageScope,
  getDopaminePanelDefaultWidth,
  getDopaminePanelWidthLimits,
} from './DopamineAssistant.utils'
import {
  DopamineResizeControls,
  useDopamineResizableWidth,
} from './useDopamineResizableWidth'

interface UseDopaminePanelWidthOptions {
  storageScope: DopamineAssistantStorageScope | null
  viewportWidth: number
}

/** The open panel's width, 360–500 px, per account. */
export const useDopaminePanelWidth = ({
  storageScope,
  viewportWidth,
}: UseDopaminePanelWidthOptions): DopamineResizeControls =>
  useDopamineResizableWidth({
    defaultWidth: getDopaminePanelDefaultWidth(viewportWidth),
    limits: getDopaminePanelWidthLimits(),
    snapToDefaultWithin: DOPAMINE_PANEL_SNAP_TO_DEFAULT_PX,
    storageKey: DOPAMINE_PANEL_WIDTH_STORAGE_KEY,
    storageScope,
  })
